import { useNewCode } from '@calendly/feature-check-react'

import { usePageHasUserGuide } from './use-page-has-user-guide'

export const useIsUserGuideViewable = () => {
  const shouldShowGettingStarted = usePageHasUserGuide()
  const guideEnabled = useNewCode('activation_gsg_v2_0')?.enabled

  return guideEnabled && shouldShowGettingStarted
}
